import { Link, useLocation } from "react-router-dom";
import { Wrench } from "lucide-react";

const links = [
  { to: "/", label: "Home", testid: "nav-link-home" },
  { to: "/#services", label: "Services", testid: "nav-link-services" },
  { to: "/#how-it-works", label: "How It Works", testid: "nav-link-how-it-works" },
  { to: "/track", label: "Track Repair", testid: "nav-link-track" },
  { to: "/warranty", label: "Warranty", testid: "nav-link-warranty" },
];

export default function Nav() {
  const loc = useLocation();
  return (
    <header className="glass-header fixed top-0 left-0 right-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-brand-logo" className="flex items-center gap-2 group">
          <span className="flex items-center justify-center w-9 h-9 rounded-xl bg-slate-900 text-amber-400 group-hover:rotate-6 transition-transform">
            <Wrench className="w-5 h-5" />
          </span>
          <span className="font-heading font-extrabold tracking-tight text-slate-900 text-lg">
            The Repair Nook
          </span>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className={`text-sm font-medium transition-colors ${
                loc.pathname === l.to ? "text-slate-900" : "text-slate-600 hover:text-slate-900"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </nav>
          <button
              data-testid="nav-cta-book"
              className="hidden sm:inline-flex items-center px-4 py-2 rounded-xl bg-amber-600 text-white text-sm font-semibold hover:bg-amber-500 transition-colors shadow-sm"
              onClick={() => (window.location.href = "/#services")}
            >Get Instant Estimate</button>
      </div>
    </header>
  );
}
